import React, { useEffect, useState } from "react";
import axios from "axios";
import * as ReactBootstrap from "react-bootstrap";
import Editbtn from "../Skills/images/circum_edit.svg";
import deletebtn from "../Skills/images/material-symbols-light_delete-outline.svg";
import viewbtn from "../Skills/images/iconoir_eye-solid.svg";
import { baseURL } from "../../config";

const MyteamactionTable = () => {
  const [posts, setPosts] = useState({ assigneeaction: [] });
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);

  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [assigneeactionToDelete, setAssigneeactionToDelete] = useState(null);
  const [viewAssigneeaction, setAssigneeaction] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);

  useEffect(() => {
    const fetchPostList = async () => {
      try {
        const { data } = await axios(`${baseURL}/myteamidpaction`);
        console.log("Fetched data:", data);
        if (Array.isArray(data.assigneeaction)) {
          setPosts({ assigneeaction: data.assigneeaction });
        } else {
          console.error("Data is not an array:", data);
        }
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    };
    fetchPostList();
  }, []);

  const handleDelete = async (assigneeactionId) => {
    try {
      setAssigneeactionToDelete(assigneeactionId);
      setShowDeleteModal(true);
    } catch (error) {
      console.error("Error deleting training:", error);
    }
  };

  const confirmDelete = async () => {
    try {
      await axios.get(
        `${baseURL}/deleteassigneeaction?id=${assigneeactionToDelete}`
      );
      const updatedAssigneeaction = posts.assigneeaction.filter(
        (assigneeaction) => assigneeaction.id !== assigneeactionToDelete
      );
      setPosts({ assigneeaction: updatedAssigneeaction });
      setShowDeleteModal(false);
    } catch (error) {
      console.error("Error deleting Training:", error);
    }
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
  };

  const handleView = (assigneeaction) => {
    setAssigneeaction(assigneeaction);
    setShowViewModal(true);
  };
  const handleCloseViewModal = () => {
    setShowViewModal(false);
  };

  const formatDate = (dateString) => {
    const options = { day: "2-digit", month: "long", year: "numeric" };
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", options);
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts.assigneeaction.slice(
    indexOfFirstPost,
    indexOfLastPost
  );

  return (
    <div>
      <div className="col-lg-12 d-flex mt-2 pb-3">
        <div className="col-lg-6">
          <h4 className="text-start">Assignee Action</h4>
        </div>
      </div>
      <ReactBootstrap.Table striped bordered hover size="sm">
        <thead className="text-center">
          <tr>
            <th>#</th>
            <th>Plan Type</th>
            <th>Due Date</th>

            <th>Employee Name</th>
            <th>Employee Id</th>

            <th>justification</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentPosts.map((assigneeaction, index) => (
            <tr key={index}>
              <td>{assigneeaction.id}</td>
              <td>{assigneeaction.plantypeaction}</td>
              <td>{formatDate(assigneeaction.planneddateaction)}</td>
              {/* <td>{assigneeaction.trainingtitle}</td>
                            <td>{assigneeaction.FirstName}</td> */}
              <td>{assigneeaction.FirstName}</td>
              <td>{assigneeaction.targetgroup}</td>

              <td>{assigneeaction.justificationaction}</td>
              <td className="text-center">
                <ReactBootstrap.Button
                  className="bg-transparent border-0"
                  variant="danger"
                  onClick={() => handleDelete(assigneeaction.id)}
                >
                  <img src={deletebtn} alt="Delete" />
                </ReactBootstrap.Button>
                <ReactBootstrap.Button
                  className="bg-transparent border-0"
                  onClick={() => handleView(assigneeaction)}
                >
                  <img src={viewbtn} alt="View" />
                </ReactBootstrap.Button>
              </td>
            </tr>
          ))}
        </tbody>
      </ReactBootstrap.Table>
      <ReactBootstrap.Modal
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
      >
        <ReactBootstrap.Modal.Header closeButton>
          <ReactBootstrap.Modal.Title>
            Confirm Deletion
          </ReactBootstrap.Modal.Title>
        </ReactBootstrap.Modal.Header>
        <ReactBootstrap.Modal.Body>
          Are you sure you want to delete this Training?
        </ReactBootstrap.Modal.Body>
        <ReactBootstrap.Modal.Footer>
          <ReactBootstrap.Button
            variant="secondary"
            onClick={handleCloseDeleteModal}
          >
            Cancel
          </ReactBootstrap.Button>
          <ReactBootstrap.Button variant="danger" onClick={confirmDelete}>
            Delete
          </ReactBootstrap.Button>
        </ReactBootstrap.Modal.Footer>
      </ReactBootstrap.Modal>
      {showViewModal && viewAssigneeaction && (
        <ReactBootstrap.Modal
          show={showViewModal}
          onHide={handleCloseViewModal}
        >
          <ReactBootstrap.Modal.Header closeButton>
            <ReactBootstrap.Modal.Title>
              View Training
            </ReactBootstrap.Modal.Title>
          </ReactBootstrap.Modal.Header>
          <ReactBootstrap.Modal.Body>
            <p>
              <b>Plan Type :</b> {viewAssigneeaction.plantypeaction}
            </p>
            <p>
              <b>Due Date : </b> {viewAssigneeaction.planneddateaction}
            </p>
            <p>
              <b>Employee Name : </b>
              {viewAssigneeaction.FirstName}
            </p>
            <p>
              <b>Employee Id : </b>
              {viewAssigneeaction.targetgroup}
            </p>
            <p>
              <b>Justification :</b> {viewAssigneeaction.justificationaction}
            </p>
          </ReactBootstrap.Modal.Body>
          <ReactBootstrap.Modal.Footer>
            <ReactBootstrap.Button
              variant="secondary"
              onClick={handleCloseViewModal}
            >
              Close
            </ReactBootstrap.Button>
          </ReactBootstrap.Modal.Footer>
        </ReactBootstrap.Modal>
      )}
      <ReactBootstrap.Pagination>
        {Array.from(
          { length: Math.ceil(posts.assigneeaction.length / postsPerPage) },
          (_, index) => (
            <ReactBootstrap.Pagination.Item
              key={index}
              onClick={() => paginate(index + 1)}
            >
              {index + 1}
            </ReactBootstrap.Pagination.Item>
          )
        )}
      </ReactBootstrap.Pagination>
    </div>
  );
};

export default MyteamactionTable;
